import { ErrorHandler, Injectable } from '@angular/core';
import {ErrorsService} from "./core/http/errors.service";
import {FrontendError} from "./shared/models/FrontendError";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private static readonly STORAGE_KEY = 'frontend-errors';
  private static errorLog: { message: string, time: Date, fullError: string }[] = GlobalErrorHandler.loadErrors();

  constructor(private errorsService: ErrorsService) {}

  static getErrors() {
    return [...this.errorLog].reverse();
  }

  static loadErrors() {
    const raw = sessionStorage.getItem(this.STORAGE_KEY);
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        return parsed.map((e: any) => ({ ...e, time: new Date(e.time) }));
      } catch (e) {
        console.warn('Fehler beim Laden der Fehlerliste:', e);
        return [];
      }
    }
    return [];
  }

  static saveErrors() {
    try {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.errorLog));
    } catch (e) {
      console.warn('Fehler beim Speichern der Fehlerliste:', e);
    }
  }

  handleError(error: any): void {
    const errObj = {
      message: error?.message || error.toString(),
      time: new Date(),
      fullError: error || ''
    };

    GlobalErrorHandler.errorLog.push(errObj);

    if (GlobalErrorHandler.errorLog.length > 30) {
      GlobalErrorHandler.errorLog.shift();
    }

    GlobalErrorHandler.saveErrors();

    const frontendError = new FrontendError(errObj.message, JSON.stringify(errObj.fullError), errObj.time);

    // send error to api
    this.errorsService.createError(frontendError).subscribe({
      error: (e) => console.warn('Fehler beim Senden des Fehlers:', e)
    });

    console.error(error);
  }

  static clearErrors() {
    this.errorLog = [];
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
